import React, { useState, useEffect } from "react";
import ArtistComboBox from "../ArtistComboBox";
import { artistsApiRequest } from "../../../api";

const handleSearch = (selection) => {
  if (!selection || !selection.slug) return null;
  window.location.href = `/artists/${selection.slug}`;
};

function ArtistSearch() {
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    function onSuccess(response) {
      if (response.records && response.records.length > 0) {
        setArtists((artists) => [...artists, ...response.records]);
      }
    }

    const fetchData = () => {
      artistsApiRequest({ all: 1 }, onSuccess);
    };

    fetchData();
  }, []);

  if (artists.length <= 0) return null;

  return (
    <ArtistComboBox
      artists={artists}
      onChange={handleSearch}
      label="Search artists"
      placeholder="Search & Browse Artists (A–Z)"
    />
  );
}

export default ArtistSearch;
